module.exports = __webpack_public_path__ + "img/y-83.0bd00186.png";